function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "snowy"
}, React.createElement("g", {
  id: "snow"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  id: "Vector",
  d: "M8 25.5V30.5",
  stroke: "#57A0EE",
  strokeWidth: 1.2,
  strokeLinecap: "round"
}), React.createElement("path", {
  id: "Vector_2",
  d: "M9.76777 26.2322L6.23223 29.7678",
  stroke: "#57A0EE",
  strokeLinecap: "round"
}), React.createElement("path", {
  id: "Vector_3",
  d: "M10.5 28H5.5",
  stroke: "#57A0EE",
  strokeLinecap: "round"
}), React.createElement("path", {
  id: "Vector_4",
  d: "M9.76777 29.7678L6.23223 26.2322",
  stroke: "#57A0EE",
  strokeLinecap: "round"
})), React.createElement("g", {
  id: "Group_2"
}, React.createElement("path", {
  id: "Vector_5",
  d: "M16 25.5V30.5",
  stroke: "#57A0EE",
  strokeWidth: 1.2,
  strokeLinecap: "round"
}), React.createElement("path", {
  id: "Vector_6",
  d: "M17.7678 26.2322L14.2322 29.7678",
  stroke: "#57A0EE",
  strokeLinecap: "round"
}), React.createElement("path", {
  id: "Vector_7",
  d: "M18.5 28H13.5",
  stroke: "#57A0EE",
  strokeLinecap: "round"
}), React.createElement("path", {
  id: "Vector_8",
  d: "M17.7678 29.7678L14.2322 26.2322",
  stroke: "#57A0EE",
  strokeLinecap: "round"
})), React.createElement("g", {
  id: "Group_3"
}, React.createElement("path", {
  id: "Vector_9",
  d: "M25 25.5V30.5",
  stroke: "#57A0EE",
  strokeWidth: 1.2,
  strokeLinecap: "round"
}), React.createElement("path", {
  id: "Vector_10",
  d: "M26.7678 26.2322L23.2322 29.7678",
  stroke: "#57A0EE",
  strokeLinecap: "round"
}), React.createElement("path", {
  id: "Vector_11",
  d: "M27.5 28H22.5",
  stroke: "#57A0EE",
  strokeLinecap: "round"
}), React.createElement("path", {
  id: "Vector_12",
  d: "M26.7678 29.7678L23.2322 26.2322",
  stroke: "#57A0EE",
  strokeLinecap: "round"
}))), React.createElement("path", {
  id: "Vector_13",
  d: "M32.7 15.4C32.7 10.8 29 7.2 24.5 7.2C23.5 7.2 22.6 7.4 21.7 7.7C21.4 4.3 18.6 1.5 15.1 1.5C11.4 1.5 8.4 4.5 8.4 8.2C8.4 9 8.6 9.8 8.8 10.5C8.5 10.4 8.1 10.4 7.8 10.4C4.1 10.4 1.1 13.4 1.1 17.1C1.1 20.7 4 23.7 7.6 23.8H24.8C29.2 23.3 32.7 19.8 32.7 15.4Z",
  fill: "#57A0EE",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinejoin: "round"
}));

var SvgSnow = function SvgSnow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSnow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/snow.56cfbb5e.svg";
export { ForwardRef as ReactComponent };